import React from "react";
import Select from "react-select";

import { IS_VALID } from "utils";

let schema = {
  className: "NotificationHistory",
  classNameLabel: "Notification History",
  limit: 10,
  columns: [
    {
      columnName: "objectId",
      type: "string"
    },
    {
      columnName: "subject",
      type: "string",
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      }
    },
    {
      columnName: "User",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
    {
      columnName: "Sender",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
    {
      columnName: "status",
      type: "string",
      headerStyle: {
        minWidth: 145
      },
      render: ({ object}) => {
        let renderValue = "";

        if (IS_VALID(object.get("status"))) {
          renderValue = object.get("status");
        }

        return renderValue;
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "SENT",
                  value: "SENT"
                },
                {
                  label: "FAILED",
                  value: "FAILED"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("status", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "type",
      type: "string",
      show: false
    },
    {
      columnName: "device",
      type: "string",
      headerStyle: {
        minWidth: 133
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "ALL",
                  value: "ALL"
                },
                {
                  label: "ANDROID",
                  value: "ANDROID"
                },
                {
                  label: "IOS",
                  value: "IOS"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("device", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "sendMode",
      columnLabel: "send mode",
      type: "string",
      headerStyle: {
        minWidth: 101,
        whiteSpace: "nowrap"
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "TEST",
                  value: "TEST"
                },
                {
                  label: "LIVE",
                  value: "LIVE"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("sendMode", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "userType",
      type: "string",
      show: false
    },
    {
      columnName: "cardTypes",
      type: "array",
      show: false
    },
    {
      columnName: "screen",
      type: "string",
      show: false
    },
    {
      columnName: "browser",
      type: "string",
      show: false
    },
    {
      columnName: "url",
      type: "string",
      show: false
    },
    {
      columnName: "message",
      type: "string",
      show: false
    },
    {
      columnName: "sendType",
      type: "string",
      columnLabel: "send Type",
      headerStyle: {
        minWidth: 154
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "IMMEDIATE",
                  value: "IMMEDIATE"
                },
                {
                  label: "SCHEDULED",
                  value: "SCHEDULED"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("sendType", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "pushDateTime",
      type: "date",
      show: false
    },
    {
      columnName: "specificUsers",
      type: "array",
      show: false
    },
    {
      columnName: "blacklistedUsers",
      type: "array",
      show: false
    },
    {
      columnName: "dateApproved",
      type: "date",
      show: false
    },
    {
      columnName: "deviceTokenCount",
      type: "number",
      show: false
    },
    {
      columnName: "memberTokenCount",
      type: "number",
      show: false
    },
    {
      columnName: "sendingStartDate",
      type: "date",
      show: false
    },
    {
      columnName: "sendingEndDate",
      type: "date",
      show: false
    },
    {
			columnName: "createdAt",
			type: "Date"
		},
		{
			columnName: "updatedAt",
			type: "Date"
		}
  ]
};

module.exports = schema;



// WEBPACK FOOTER //
// ./components/NotificationHistory/NotificationHistorySchema.js